import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useContext } from "react"
import { CalendarContext } from "../context"
import { MoveContext } from "./moveContext"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: 180,
        height: 40,
        color: "white",
        zIndex: 100,
        borderRadius: 6,
        padding: "0 20px 0 10px",
        boxSizing: "border-box",
        pointerEvents: "none",
        opacity: 0.8,
    },
}))
interface ComponentProps {
    text?: string
}
const offsetX = 120
const offsetY = 260
const MoveItem = (props: ComponentProps) => {
    const classes = useStyles()
    const { movableBoard, isWeChat } = useContext(CalendarContext)
    const { position } = useContext(MoveContext)
    const isMoving = movableBoard !== null && movableBoard.id
    let style = {}
    let showText = ""
    if (isMoving) {
        if (position) {
            const { article_type, name = "", author, description } = movableBoard || {}
            const { color_code: color } = article_type || {}
            style = {
                left: position.x - offsetX,
                top: position.y - offsetY,
                backgroundColor: color,
            }
            showText = name
            if (isWeChat) {
                showText = `${author ? `【${author.name}】` : ""}${description}`
            }
        }
    }
    return (
        <Fragment>
            {
                isMoving && (
                    <div
                        className={classes.root}
                        style={style}
                    >
                        {showText}
                    </div>
                )
            }
        </Fragment>
    )
}

export default MoveItem
